import React from 'react';
import { Link } from 'react-router-dom';
import useSeo from '../hooks/useSeo';
import './Pages.css';

function ManagedServicePlans() {
  useSeo(
    'Managed Service Plans | Rev-Tech Services',
    'Rev-Tech managed service plans provide predictable support and protection across IT environments with tiered Core, Advanced, and TotalCare options.',
    {
      canonical: 'https://www.rev-technology.com/services/managed-service-plans'
    }
  );

  return (
    <div className="page">
      <h1>Managed Service Plans</h1>
      <section className="content-section">
        <p>
          Our managed service plans give you predictable support and protection across your entire IT environment.
          Whether you need Core, Advanced, or TotalCare, Rev-Tech builds a plan that aligns with your business goals.
        </p>
      </section>

      <section className="content-section">
        <h2>What&apos;s Included</h2>
        <ul className="values-list">
          <li><strong>Plan consultation:</strong> We help you select the right plan for your operations and budget.</li>
          <li><strong>Tiered coverage:</strong> Core, Advanced, and TotalCare packages offer increasing levels of support and security.</li>
          <li><strong>Custom onboarding:</strong> Smooth transition and setup across your devices and systems.</li>
          <li><strong>Ongoing optimization:</strong> Regular reviews to ensure your plan continues to meet your needs.</li>
        </ul>
      </section>

      <section className="content-section">
        <h2>Why it matters</h2>
        <p>
          A managed service plan provides consistent IT support and financial predictability.
          Rev-Tech helps you avoid surprise costs while giving your team the tools and security they need.
        </p>
      </section>

      <Link to="/services" className="cta-button">Back to Services</Link>
    </div>
  );
}

export default ManagedServicePlans;
